import React from "react";
import classNames from "classnames";
import { PanelHeaderProps } from "./PropsType";

export default function PanelHeader(props: PanelHeaderProps) {
  const { children, className, onExpand, onFullscreen, tool, ...other } = props;
  const styleClass = classNames("PanelHeader", className);
  const handleExpandClick = () => {
    if (props.onExpand) {
      props.onExpand();
    }
  };

  const handleFullscreenClick = () => {
    if (props.onFullscreen) {
      props.onFullscreen();
    }
  };
  return (
    <div className={styleClass} {...other}>
      {children}
      {!!tool ? (
        <div className="PanelHeader-toolbar">
          <i
            className="Icon iconfont icon-icon--"
            onClick={handleFullscreenClick}
          />
          <i
            className="Icon iconfont icon-jianhao"
            onClick={handleExpandClick}
          />
        </div>
      ) : null}
    </div>
  );
}

PanelHeader.fnName = "PanelHeader";
